import { colors } from './tokens';

/** Spread onto Slider sx — value label pinned dead-center on the thumb. */
export const customSlider = {
  color: colors.secondary.main,
  height: 8,
  '& .MuiSlider-rail': {
    backgroundColor: colors.neutral.sliderRail,
    opacity: 1,
  },
  '& .MuiSlider-track': {
    backgroundColor: colors.secondary.main,
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: colors.secondary.main,
    border: `2px solid ${colors.secondary.main}`,
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&::before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    fontWeight: 600,
    background: 'unset',
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: '50%',
    backgroundColor: colors.secondary.main,
    color: colors.neutral.white ?? '#fff',
    border:`3px solid white`,
    position: 'absolute !important',
    top: '50% !important',
    left: '50% !important',
    right: 'auto !important',
    bottom: 'auto !important',
    transformOrigin: 'center center',
    transform: 'translate(-50%, -50%) scale(0) !important',
    '&::before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(-50%, -50%) scale(1) !important',
    },
    '& > *': {
      transform: 'none',
    },
  },
};

export default customSlider;